import { createSlice } from "@reduxjs/toolkit";

const emptyResourceHolder = {
  meta: {
    count: 0,
    lastFetched: null,
  },
  list: [],
};

const initialState = {
  account: null,
  pbx: null,
  number: "",

  users: { ...emptyResourceHolder },
};

const { actions, reducer } = createSlice({
  name: "dial",
  initialState,
  reducers: {
    setDialNumber(state, action) {
      state.number = action.payload;
    },
    setDialUser(state, action) {
      state.user = action.payload;
    },
    setDialPbx(state, action) {
      state.pbx = action.payload;
      state.user = null;
      state.users = { ...emptyResourceHolder };
    },

    // Lists
    setDialUserStore: (state, action) => {
      state.users = {
        list: action.payload.sippeers,
        meta: { count: action.payload.count, lastFetched: new Date().toString() },
      };
    },

    // Reset actions
    clearDialPbx(state) {
      state.pbx = null;
      state.account = null;
      state.number = "";
      state.users = { ...emptyResourceHolder };
    },
    resetDial() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase("root/clearAuthData", () => {
        return initialState;
      })
      .addCase("domain/setPbx", (state, action) => {
        if (!state.pbx) {
          state.pbx = action.payload.pbx;
        }
      });
  },
});

export const { setDialNumber, setDialUser, setDialPbx, setDialUserStore, clearDialPbx, resetDial } = actions;

export default reducer;
